import React from 'react';
import { Users, Calendar, Star } from 'lucide-react';

const WhyChooseUs = () => {
  const stats = [
    {
      icon: Users,
      value: '10K+',
      label: 'Happy Customers',
      description: 'Trust our products worldwide',
    },
    {
      icon: Calendar,
      value: '10+',
      label: 'Years Experience',
      description: 'In bio-peptide innovation',
    },
    {
      icon: Star,
      value: '5 Stars',
      label: 'Customer Reviews',
      description: 'Exceptional satisfaction rating',
    },
  ];

  return (
    <section id="why-choose-us" className="py-24 px-4 sm:px-6 lg:px-8 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100 rounded-full filter blur-3xl opacity-20 -z-0"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-sky-100 rounded-full filter blur-3xl opacity-20 -z-0"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-bold text-blue-900 mb-6">
            Why Choose Us
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-sky-400 to-blue-900 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trusted by thousands for quality, authenticity, and results
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="group relative"
              >
                {/* Card */}
                <div className="relative bg-gradient-to-br from-white to-blue-50 rounded-3xl p-10 border-2 border-blue-100 hover:border-blue-300 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3">
                  {/* Icon container */}
                  <div className="mb-6 flex justify-center">
                    <div className="relative">
                      {/* Animated ring */}
                      <div className="absolute inset-0 bg-blue-900 rounded-full animate-ping opacity-20"></div>
                      <div className="relative w-20 h-20 bg-blue-900 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
                        <Icon className="w-10 h-10 text-white" />
                      </div>
                    </div>
                  </div>

                  {/* Value */}
                  <div className="text-center mb-4">
                    <div className="text-5xl font-bold text-blue-900 mb-2 group-hover:scale-110 transition-transform duration-300 inline-block">
                      {stat.value}
                    </div>
                  </div>

                  {/* Label */}
                  <h3 className="text-2xl font-bold text-blue-900 text-center mb-3">
                    {stat.label}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 text-center leading-relaxed">
                    {stat.description}
                  </p>

                  {/* Bottom accent */}
                  <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-sky-400 to-blue-900 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-b-3xl"></div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Trust indicators */}
        <div className="mt-20 grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-3xl p-8 text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-4">Verified Authenticity</h3>
            <p className="text-blue-100 leading-relaxed">
              Every product comes with a unique validation code to ensure authenticity. 
              Verify your purchase instantly on our platform.
            </p>
          </div>
          <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-3xl p-8 text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-4">Premium Quality</h3>
            <p className="text-blue-100 leading-relaxed">
              Manufactured to the highest pharmaceutical standards with rigorous testing 
              and quality control at every stage.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
